<template>
  <v-layout row wrap :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-flex xs12>
      <v-card :key="activity.stackId + 'card-detail'">
        <v-card-title>
          Activity details
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="pt-2">
            <v-card>
              <v-toolbar
                dense
                card
                class="elevation-2"
                @click="showOutput = !showOutput"
              >
                <v-toolbar-title
                  class="body-2 beez-bold "
                  v-text="'Activity Data'"
                />
                <v-spacer />
                <v-btn icon small class="mb-2">
                  <v-icon
                    >{{
                      showOutput ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    }}
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="showOutput">
                <execution-activity-admin-task
                  v-if="
                    activity &&
                      activity.camundaProperties &&
                      activity.camundaProperties.executionId
                  "
                  :activity="activity"
                />
                <v-flex xs12>
                  <displayExecutionSchema :input="schemaOutput" />
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash'
import ExecutionActivityAdminTask from '@/components/execution/ExecutionActivityAdminTask.vue'
import DisplayExecutionSchema from '@/components/execution/DisplayExecutionSchema.vue'

export default {
  components: {
    DisplayExecutionSchema,
    ExecutionActivityAdminTask
  },
  name: 'ExecutionActivityDetail',
  props: {
    activity: Object
  },
  data: function() {
    return {
      showOutput: false,
      schemaOutput: []
    }
  },
  async mounted() {
    this.fillOutputSchema()
  },
  methods: {
    getFormType(variable) {
      //  STRING, NUMBER, BOOLEAN, OBJECT, DATE, FILE, ARRAY - possible input options
      if (_.isArray(variable.value)) {
        return 'array'
      } else if (_.isString(variable.value)) {
        switch (variable.type) {
          case 'STRING':
            return 'text'
          case 'NUMBER':
            return 'text'
          case 'BOOLEAN':
            return 'checkbox'
          case 'DATE':
            return 'date'
          case 'FILE':
            return 'file'
          default:
            return 'text'
        }
      } else if (_.isDate(variable.value)) {
        return 'date'
      } else if (_.isNumber(variable.value)) {
        return 'text'
      } else if (_.isBoolean(variable.value)) {
        return 'checkbox'
      } else if (_.isUndefined(variable.value)) {
        return 'text'
      } else if (_.isNull(variable.value)) {
        return 'text'
      } else if (_.isObject(variable.value)) {
        return 'object'
      }
    },
    fillOutputSchema() {
      for (let [key, value] of Object.entries(this.activity.variables)) {
        if (value) {
          this.schemaOutput.push({
            key: key,
            type: this.getFormType(value),
            options: {
              label: key,
              value: value.value
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped />
